import type { BreadcrumbItem } from 'components/ui/breadcrumbs';
import Script from 'next/script';

const basePath = process.env.INTEGRA_DOMAIN;

export function getBreadcrumbLdList({ breadcrumbs }: { breadcrumbs: BreadcrumbItem[] }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.name,
        item: crumb.href && crumb.href.startsWith('http') ? crumb.href : `${basePath}${crumb.href}`,
      };
    }),
  };
}

export function BreadcrumbsLdJson({ breadcrumbs }: { breadcrumbs: BreadcrumbItem[]; withCurrent: boolean }) {
  return (
    <Script
      id="breadcrumbList"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(getBreadcrumbLdList({ breadcrumbs })),
      }}
    />
  );
}
